<template>
  <div >
    <div class="tab-box">
    <el-row>
      <el-form :inline="true" :model="tradForm" class="demo-form-inline">
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="handleTime"
            style="width:220px"
             size="small"
             :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="类型">
          <el-select  size="small" v-model="tradForm.tradeType" clearable placeholder="请选择" @change="handleChangeTradeType">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <Table :props="table.props" :header="table.header" :data="table.data" v-loading="loading" />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tradForm: {
        startDateX: '',
        endDateX: '',
        tradeType: undefined,
        pageNo: 1,
        pageSize: 10
      },
      time: this.getTime(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 0,
      // 查询的页码
      filter: {},
      loading: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '交易流水号',
            align: 'left',
            prop: 'tradeNo',
            'show-overflow-tooltip': true,
            'min-width': '300/1360'
          },
          {
            label: '交易时间',
            align: 'left',
            prop: 'tradeTime',
            'show-overflow-tooltip': true,
            'min-width': '260/1360',
            formatter: params => {
              return this.$moment(params.tradeTime).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '类型',
            align: 'left',
            prop: 'tradeType',
            'show-overflow-tooltip': true,
            'min-width': '100/1360',
            formatter: params => {
              return this.$consts.financialTradText[params.tradeType]
            }
          },
          {
            label: '交易金额',
            align: 'right',
            prop: 'tradeMoney',
            'show-overflow-tooltip': true,
            'min-width': '120/1360',
            formatter: params => {
              if (params.tradeMoney > 0) {
                return '+' + this.$consts.toLocaleString(params.tradeMoney || 0)
              } else {
                return this.$consts.toLocaleString(params.tradeMoney || 0)
              }
            }
          },
          {
            label: '账户余额',
            align: 'right',
            prop: 'accountBalance',
            'show-overflow-tooltip': true,
            'min-width': '160/1360',
            formatter: params => {
              return this.$consts.toLocaleString(params.accountBalance || 0)
            }
          },
          {
            label: '备注',
            align: 'left',
            prop: 'remark',
            'show-overflow-tooltip': true,
            'min-width': '360/1360'
          }
        ],
        data: []
      },
      options: this.$consts.financialTradOptions
    }
  },
  methods: {
    getTime() {
      const timestamp = new Date().getTime()
      const newDate = new Date(timestamp - 6 * 24 * 3600 * 1000)
      return [newDate, new Date()]
    },
    getTradePageList() {
      this.loading = true
      this.tradForm.pageNo = this.currentPage
      this.tradForm.pageSize = this.pageSize
      if (this.time.length > 0) {
        this.tradForm.startDateX = this.$moment(this.time[0]).format('YYYY-MM-DD 00:00:00')
        this.tradForm.endDateX = this.$moment(this.time[1]).format('YYYY-MM-DD 23:59:59')
      } else {
        this.tradForm.startDateX = undefined
        this.tradForm.endDateX = undefined
      }
      this.$service.getTradePageList(this.tradForm).then(data => {
        this.table.data = data.rows || []
        this.totalCount = data.total || 0
        this.loading = false
      })
    },
    handleTime(val) {
      this.getTradePageList()
    },
    handleChangeTradeType() {
      this.getTradePageList()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.getTradePageList()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTradePageList()
    }
  },
  created() {
    this.getTradePageList()
  }
}
</script>
<style lang="stylus" scoped>
.tab-box {
  margin: 0px 16px;
  padding: 24px 25px;
  background-color: #fff;
  border-radius 2px
}
</style>
